<ng-container *transloco="let t">
    <div class="w-full grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-2 mb-2">
        <tui-radio-block
            *ngFor="let item of options"
            [formControl]="paymentTypeCtrl"
            contentAlign="right"
            size="l"
            [item]="item"
        >
            <div class="flex items-center gap-1">
                <tui-svg [src]="item | paymentTypeIcon"></tui-svg>
                <span class='ml-1.5'>{{ t(item | paymentTypeLabel : orderType) }}</span>
            </div>
        </tui-radio-block>
    </div>

    <div
        *ngIf="paymentTypeCtrl.value === PaymentType.BankTransfer && bankTransferInformation() !== null"
        class="mt-2 p-4 text-base bg-blue-50 text-gray-700 rounded block ng-star-inserted"
    >
        {{ bankTransferInformation() }}
    </div>
</ng-container>
